module.exports = __webpack_public_path__ + "img/HomeIcon.8b41ca2e.svg";